import { useToastAlert } from '@design-systems/canvas-ui'
import { useContext, useEffect, useState } from 'react'
import { UserContext } from 'App/UserContext'
import { IS_IMPERSONATING_KEY } from '../impersonation/impersonationStorage'
import { getJwtExpiryMs, USER_LOGIN_STATE_KEY } from './userLoginCache'

const WARNING_WINDOW_MS = 10 * 60 * 1000

const SessionExpiryToaster = () => {
  const { sparkUser } = useContext(UserContext)
  const makeToast = useToastAlert()
  const [hasWarned, setHasWarned] = useState(false)
  const token = sparkUser?.userProfileToken
  const isImpersonating = localStorage.getItem(IS_IMPERSONATING_KEY) === 'true'

  useEffect(() => {
    if (!token || isImpersonating || hasWarned) return

    const expiryMs = getJwtExpiryMs(token)
    if (!expiryMs) return

    const showWarning = () => {
      setHasWarned(true)
      makeToast({
        variant: 'caution',
        heading: 'Your session is about to expire',
        message: 'Refresh your session to continue working.',
        autoHideDuration: WARNING_WINDOW_MS,
        links: [
          {
            text: 'Refresh session',
            onClick: () => {
              localStorage.removeItem(USER_LOGIN_STATE_KEY)
              window.location.reload()
            },
          },
        ],
      })
    }

    const delay = expiryMs - WARNING_WINDOW_MS - Date.now()
    if (delay <= 0) {
      showWarning()
      return
    }

    const timeoutId = window.setTimeout(showWarning, delay)
    return () => window.clearTimeout(timeoutId)
  }, [hasWarned, isImpersonating, makeToast, token])

  return null
}

export default SessionExpiryToaster
